import React from 'react'

const Content = () => {
  return (
    <section className='bg-accent-secondary pb-12'
        data-aos='fade-up'
        data-aos-offset='350'>
        <div className='container mx-auto h-full relative pt-20'>
        <h2
            className='h2 mb-6 xl:mb-12 text-center text-secondary font-primary'
            data-aos='fade-down'
            data-aos-delay='100'
          >
            Video Animasi Interaktif
          </h2>
            <div className="flex-1 items-center">
                <div className='flex flex-row items-center'>
                <iframe className='mx-auto' width="560" height="315" src="https://www.youtube.com/embed/nhaTgntD5wU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/uoJg2RS6_BI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                <div className='flex flex-row items-center mt-5'>
                <iframe className='mx-auto' width="560" height="315" src="https://www.youtube.com/embed/LwnLurexn1Y" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/VJ1SvCrXRWk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                <div className='flex flex-row items-center mt-5'>
                <iframe className='mx-auto' width="560" height="315" src="https://www.youtube.com/embed/N0Nb3MBSXEw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/YIGfSp5LPm8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </section >
  )
}

export default Content